<div class="d-flex justify-content-center position-relative design-block-preview"
    (mouseenter)="MouseEntered()"
    (mouseleave)="MouseLeave()">
    @if (showActionMenu) {
        <div class="design-block-action-menu">
            <div class="d-flex gap-2 px-2">
                @if (showImageActions) {
                    <lib-icon-button
                        qaTag="design-block-action-menu-media-gallery-icon-button"
                        [kind]="ButtonKind.NeutralTertiary"
                        [icon]="Icon.Common.CollectionCircleAdd"
                        [disabled]="disableAddImage"
                        (clicked)="MediaGalleryClicked()">
                    </lib-icon-button>
                    <lib-icon-button
                        qaTag="design-block-action-menu-add-item-icon-button"
                        [kind]="ButtonKind.NeutralTertiary"
                        [icon]="Icon.Common.Add"
                        [disabled]="disableAddImage"
                        (clicked)="AddClicked()">
                    </lib-icon-button>
                    <lib-icon-button
                        qaTag="design-block-action-menu-remove-item-icon-button"
                        [kind]="ButtonKind.NeutralTertiary"
                        [icon]="Icon.Common.Remove"
                        [disabled]="disableRemoveImage"
                        (clicked)="RemoveClicked()">
                    </lib-icon-button>
                }
                <lib-icon-button
                    qaTag="design-block-action-menu-move-up-icon-button"
                    [kind]="ButtonKind.NeutralTertiary"
                    [icon]="Icon.Common.ArrowUpward"
                    [disabled]="Scope.websiteBlockData.OrderIndex <= 0"
                    (clicked)="MoveUpClicked()">
                </lib-icon-button>
                <lib-icon-button
                    qaTag="design-block-action-menu-move-down-icon-button"
                    [kind]="ButtonKind.NeutralTertiary"
                    [icon]="Icon.Common.ArrowDownward"
                    [disabled]="Scope.websiteBlockData.OrderIndex >= Scope.websiteBlockCount - 1"
                    (clicked)="MoveDownClicked()">
                </lib-icon-button>
                <lib-icon-button 
                    qaTag="design-block-action-menu-copy-icon-button"
                    [kind]="ButtonKind.NeutralTertiary"
                    [icon]="Icon.Common.ContentCopy"
                    (clicked)="CopyClicked()">
                </lib-icon-button>
                @if (showEdit) {
                    <lib-icon-button
                        qaTag="design-block-action-menu-edit-icon-button"
                        [kind]="ButtonKind.NeutralTertiary"
                        [icon]="Icon.Common.Edit"
                        [badgeText]="showEditBadgeError ? '!' : ''"
                        (clicked)="EditClicked()">
                    </lib-icon-button>
                }
                <lib-icon-button
                    qaTag="design-block-action-menu-delete-icon-button"
                    [kind]="ButtonKind.DangerTertiary"
                    [icon]="Icon.Common.DeleteOutline"
                    (clicked)="DeleteClicked()">
                </lib-icon-button>
            </div>
        </div>
    }
    <ng-content></ng-content>
</div>
